
import { Component, Vue } from "vue-property-decorator";
import { Toast } from "vant";
import { Service } from "src/decorator";
import { EmployerActivityService, rightsService } from "src/services";
import dayjs from "dayjs";
import globalConfig from "src/config/index";
import merge from 'webpack-merge';

@Component
export default class RightsList extends Vue
{

    /**
     * 选中id
     * @private
     * @returns number
     */
    private checkId: any = null;



    /**
     * 搜索关键字
     * @private
     * @returns string
     */
    private filters: any =
    {
        status: 2
    };

    /**
     * 加载
     */
    private loading:boolean = false;

    /**
     * tab选中
     * @private
     * @returns number | string
     */
    private active: number | string = "2";

    /**
     * 时间处理工具
     * @private
     * @returns dayjs
     */
    private dayjs: any = dayjs;

    /**
     * 订单列表
     * @private
     * @returns Array<any>
     */
    private couponList: Array<any> = [];


    /**
     * 已使用/已失效(满减)
     * @private
     * @returns Array<any>
     */
    private isReductionMask(item) {
        if(item.status !== 2 && item.couponType == 2) {
            return true;
        } else {
            return false;
        }
    }


    /**
     * 已使用/已失效(折扣)
     * @private
     * @returns Array<any>
    */
    private isDiscountMask(item) {
        if(item.status !== 2 && item.couponType == 4) {
            return true;
        } else {
            return false;
        }
    }


     /**
     * 获取订单列表
     * @private
     * @returns
     */
    protected async loadData(parameter: any): Promise<any> {
        try {
        let { content: res } = await EmployerActivityService.instance.getCouponList(Object.assign(parameter,this.filters));
            return res.data
        } catch (err) {
            Toast(err);
        }
    }


    /**
     * 切换使用说明
     * @private
     * @returns
     */
    private changeShowDesc (item) {
        item.isShowUseDesc = !item.isShowUseDesc
    }

    /**
     * 组件创建钩子
     * @private
     * @returns void
     */
    private created(): void
    {
        if (this.$route.query && this.$route.query.active)
        {
            this.filters.status = (this.$route.query.active as string);
            this.active = this.$route.query.active + "";
        }
        else
        {
            this.filters.status = 2;
            this.active = "2";
        }
    }



    /**
     * 切换
     * @private
     * @returns void
     */
    private onTabChange(data: any): void
    {
        this.filters.status = data
        this.$router.push({query:merge({},{'active':data})});
        (this.$refs["myUPageList"] as any).onRefresh();
    }

    /**
     * 跳转页面
     * @private
     * @returns void
     */
    private onGopage(item:any): void
    {
        // 用券时间
        const stateDate = item.useTimeDesc && item.useTimeDesc.split('-')[0]
        // 当前时间
        const date = new Date()
        if(dayjs(date) < dayjs(stateDate)) {
           Toast('未到优惠券可用时间！')
            return
        }
        
        if (item.id)
        {
            this.$router.push({name: 'coupon-list-use', query: {id: item.id+""}});
        }
        else
        {
            this.$router.push({name: 'coupon-list-use'});
        }
    }

    /**
     * 激活
     * @private
     * @returns void
     */
    private async onActive(): Promise<void>
    {
        try
        {
            await rightsService.instance.clientActive(this.checkId);
            Toast("激活成功");
            setTimeout(() => {
                this.$router.push({name: "rights-detail", query: {id: this.checkId + ""}});
            }, 50)
        }
        catch(err)
        {
            Toast(err);
        }
    }
    
}
